import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { RequirementReviewStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";
import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export const REQUIREMENTS_WITH_ERRORS: Record<RequirementType, boolean> = {
  [RequirementType.SharedFile]: false,
  [RequirementType.Signature]: false,
  [RequirementType.IdentityVerification]: true,
  [RequirementType.BackgroundCheck]: true,
  [RequirementType.InsuranceCoverage]: true,
  [RequirementType.Registration]: false,
  [RequirementType.TaxVerification]: false,
  [RequirementType.PayoutMethod]: false
};

export const convertFormApprovalDataToReviewStrategy = (payload: {
  isApprovalRequired: boolean;
  reviewStrategy?: RequirementReviewStrategy;
  type: RequirementType;
  contextType?: SharedFileRequestContextType;
}): RequirementReviewStrategy => {
  const simpleReviewStrategy = payload.isApprovalRequired
    ? RequirementReviewStrategy.AlwaysRequired
    : RequirementReviewStrategy.NeverRequired;

  const withErrorsReviewStrategy = payload.reviewStrategy
    ? payload.reviewStrategy
    : RequirementReviewStrategy.NeverRequired;

  // Shared files also require to look at context type to determine the review stratergy
  if (
    payload.type === RequirementType.SharedFile &&
    payload.contextType !== SharedFileRequestContextType.None
  ) {
    return withErrorsReviewStrategy;
  }

  if (REQUIREMENTS_WITH_ERRORS[payload.type]) {
    return withErrorsReviewStrategy;
  } else {
    return simpleReviewStrategy;
  }
};

export const getReviewStrategyDefaultValues = (
  withErrorsReviewStrategy: boolean
):
  | { isApprovalRequired: boolean }
  | { reviewStrategy: RequirementReviewStrategy } => {
  if (withErrorsReviewStrategy) {
    return {
      reviewStrategy: RequirementReviewStrategy.OnFail
    };
  } else {
    return {
      isApprovalRequired: false
    };
  }
};

export const REVIEW_STRATEGY_ON_FAIL_COPY =
  "Only require when there are flags for review or validations fail (auto-approve if passed)";
export const REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY =
  "Always require (every submission)";
export const REVIEW_STRATEGY_NEVER_REQUIRED_COPY =
  "Never require (approval step is skipped)";
